import { t } from './i18n';

export const REGISTER_PARTNER_CELEB_ACTION = 'registerPartnerCeleb';
export const UNREGISTER_PARTNER_CELEB_ACTION = 'unregisterPartnerCeleb';

export const IS_CELEB_PARTNER = 2;

export function getUserIsCeleb(user) {
  const raw = user?.is_celeb ?? user?.IsCeleb;
  if (raw === null || raw === undefined) return 0;
  const n = Number(raw);
  return Number.isNaN(n) ? 0 : n;
}

export function canRegisterPartnerCeleb(user) {
  return getUserIsCeleb(user) !== IS_CELEB_PARTNER;
}

export function canUnregisterPartnerCeleb(user) {
  return getUserIsCeleb(user) === IS_CELEB_PARTNER;
}

/** @returns {'registerPartnerCeleb'|'unregisterPartnerCeleb'|null} */
export function getPartnerCelebAction(user) {
  if (canUnregisterPartnerCeleb(user)) return UNREGISTER_PARTNER_CELEB_ACTION;
  if (canRegisterPartnerCeleb(user)) return REGISTER_PARTNER_CELEB_ACTION;
  return null;
}

export function mapPartnerCelebError(err) {
  const apiMsg = err?.data?.msg || err?.data?.message;
  switch (err?.status) {
    case 404:
      return t('user.partnerCeleb.error.notFound');
    case 409:
      return apiMsg || t('user.partnerCeleb.error.conflict');
    default:
      return apiMsg || err?.message || t('user.partnerCeleb.error.generic');
  }
}
